import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6f688d5c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "morph-figure" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "part-1" }, null, -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "part-2" }, null, -1));
const _hoisted_4 = [
    _hoisted_2,
    _hoisted_3
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: _normalizeClass(["figure", {
                    circle: _ctx.currentState === 1,
                    square: _ctx.currentState === 2,
                    cross: _ctx.currentState === 3,
                    rotateCross: _ctx.currentState === 4,
                    triangle: _ctx.currentState === 5,
                }])
        }, _hoisted_4, 2)
    ]));
}
